import React from 'react'
import Logo from '@assets/images/stakes-footer-logo.svg';

export const FooterLogo = () => {
    return <img src={Logo} alt='Stakes Footer Logo'/>
}
